/**
 * Centralized API endpoint constants
 * All endpoints include the /api/ prefix for Vite proxy routing
 */

export const API_ENDPOINTS = {
  ask: '/api/v1/ask',
  askOperation: '/api/v1/ask/operations/{operationId}',
  chat: '/api/v1/chat',
  invokeText: '/api/v1/invoke/text',
  invokeImage: '/api/v1/invoke/image',
  invokeConversations: '/api/v1/invoke/conversations',
} as const

export function getAskOperationUrl(operationId: string): string {
  return API_ENDPOINTS.askOperation.replace('{operationId}', encodeURIComponent(operationId))
}
